import React, { FunctionComponent, memo, ReactElement } from 'react';
import editButtonStyles from './editButtonStyles';
import { Button } from '@material-ui/core';
import CreateIcon from '@material-ui/icons/Create';

interface IEditButtonProps {
  size?: 'small' | 'large';
  border?: boolean;
  action: (event: any) => void;
  disabled?: boolean;
  className?: string;
  label?: string | ReactElement;
}

const EditCalculationButton: FunctionComponent<IEditButtonProps> = memo(
  ({ size = 'large', border = true, action, disabled = false, className = '', label, ...rest }) => {
    const styles = editButtonStyles();
    const buttonSize = size === 'small' ? styles.small : styles.large;
    const classes = [styles.button, buttonSize, className];

    if (border === false) {
      classes.push(styles.noBorder);
    }

    return (
      <Button
        onClick={action}
        classes={{
          label: styles.buttonLabel,
        }}
        className={classes.join(' ')}
        {...(disabled ? { disabled: true } : {})}
        {...rest}
      >
        <CreateIcon className={styles.image} />
        {label}
      </Button>
    );
  },
);

export default EditCalculationButton;
